export default "__VITE_ASSET__BPxON84d__"